import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  minW: ['unset', null, '460px'],
  form: {
    '.chakra-form-control': {
      '.chakra-form__label': {
        color: 'gray.500',
        fontSize: 'xs',
      },
    },
    'a[href*="forgot-password"]': {
      fontWeight: 'medium',
    },
    '.chakra-button[data-cy*="loginSubmit"]': {
      bgGradient: 'linear(to-b, alpha.200, alpha.400)',
      boxShadow:
        '0px 0px 0px 2px #E57D24 inset, 0px 0px 0px 4px #003541 inset, 0px 0px 0px 5px #00B9E1 inset',
      color: 'white',
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.60)',
      fontWeight: 'black',
      textTransform: 'uppercase',
      fontSize: 'sm',
      borderRadius: 'lg',
      _hover: {
        bg: 'alpha.500',
      },
      _focus: {
        bg: 'alpha.500',
        boxShadow:
          '0px 0px 0px 2px #E57D24 inset, 0px 0px 0px 4px #003541 inset, 0px 0px 0px 5px #00B9E1 inset',
        color: 'white',
        textShadow: '1px 1px 0px rgba(0, 0, 0, 0.50)',
        border: 'none',
      },
    },
    'button[aria-label*="password toggle"]': {
      top: '2px',
    },
  },
};

export const Title: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: '4',
  mt: [null, null, '9'],
};
